import React from 'react';
import { red } from "material-colors";
import { useTranslation } from 'react-i18next';

import Link from "@biuwer/common/src/components/link";
import History from "@biuwer/core/src/history";
import utilsLib from '@biuwer/common/src/libs/utils-lib';

const PageNotFound = () => {

    const { t } = useTranslation();
    const isBiuwerApp = utilsLib.isBiuwerApp();

    return (
        <div className="not-found-page animated fadeIn" style={{paddingTop: 100}}>
            <div className="text-center">
                <i className="material-icons" style={{fontSize: 70, color: red[600]}}>error_outline</i>
            </div>
            <div className="mt40 mb25 text-center">
                <h1 className="mt30 fs26">{t('auth.pageNotFound.pageNotFoundMessage')}</h1>
                <div className="mt30">
                    {isBiuwerApp && (
                        <>
                            <Link to="/">{t('auth.pageNotFound.goHomePageMessage')}</Link> | <span className="span-link" onClick={() => History.goBack()}>{t('auth.pageNotFound.goBackMessage')}</span>
                        </>
                    )}
                </div>
            </div>
        </div>
    );
};

export default PageNotFound;